/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { mcpRegistriesClearCache } from "../funcs/mcpRegistriesClearCache.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ClearMCPRegistryCacheRequest,
  ClearMCPRegistryCacheSecurity,
} from "../models/operations/clearmcpregistrycache.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type McpRegistriesClearCacheMutationVariables = {
  request: ClearMCPRegistryCacheRequest;
  security?: ClearMCPRegistryCacheSecurity | undefined;
  options?: RequestOptions;
};

export type McpRegistriesClearCacheMutationData = void;

export type McpRegistriesClearCacheMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * clearCache mcpRegistries
 *
 * @remarks
 * Clear the registry cache for a specific registry (admin only)
 */
export function useMcpRegistriesClearCacheMutation(
  options?: MutationHookOptions<
    McpRegistriesClearCacheMutationData,
    McpRegistriesClearCacheMutationError,
    McpRegistriesClearCacheMutationVariables
  >,
): UseMutationResult<
  McpRegistriesClearCacheMutationData,
  McpRegistriesClearCacheMutationError,
  McpRegistriesClearCacheMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildMcpRegistriesClearCacheMutation(client, options),
    ...options,
  });
}

export function mutationKeyMcpRegistriesClearCache(): MutationKey {
  return ["@gram/client", "mcpRegistries", "clearCache"];
}

export function buildMcpRegistriesClearCacheMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: McpRegistriesClearCacheMutationVariables,
  ) => Promise<McpRegistriesClearCacheMutationData>;
} {
  return {
    mutationKey: mutationKeyMcpRegistriesClearCache(),
    mutationFn: function mcpRegistriesClearCacheMutationFn({
      request,
      security,
      options,
    }): Promise<McpRegistriesClearCacheMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(mcpRegistriesClearCache(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
